module.exports = __webpack_public_path__ + "img/04-1-1Amazon服务.8cf63a84.svg";